export default {
  FLICKER_DELAY: 300,
  TOAST_DELAY: 1000,
};
